import redux, { Dispatch, Reducer } from 'redux'
import {
  QUOTE_STATUS_QUERY,
  QuoteStatusData,
  QuoteStatusVariables
} from '../graphql/query/quote.status'
import { client } from '../lib/client'
import { GetState } from './index'

export interface HistoryState {
  list: {
    [key: string]: any
  }
}

type ActionTypes = 'HISTORY_CREATE' | 'HISTORY_UPDATE' | 'HISTORY_UPDATE_MANY' | 'HISTORY_DELETE';
type Action = redux.Action<ActionTypes> & redux.AnyAction

const initialState: HistoryState = {
  list: {}
}

export const actionTypes: {[key: string]: ActionTypes} = {
  CREATE: 'HISTORY_CREATE',
  UPDATE: 'HISTORY_UPDATE',
  UPDATE_MANY: 'HISTORY_UPDATE_MANY',
  DELETE: 'HISTORY_DELETE',
}

export const history: Reducer<HistoryState, Action> = (state = initialState, action: Action) => {
  let next: any

  switch (action.type) {
    case actionTypes.CREATE:
      next = {
        ...state
      }

      next.list[action.entry.id] = action.entry

      return next

    case actionTypes.UPDATE:
      next = {
        ...state
      }

      next.list[action.entry.id] = {
        ...next.list[action.entry.id],
        ...action.entry
      }

      return next

    case actionTypes.UPDATE_MANY:
      next = {
        ...state
      }

      action.entries.forEach((entry: any) => {
        next.list[entry.id] = {
          ...next.list[entry.id],
          ...entry
        }
      })

      return next

    case actionTypes.DELETE:
      return Object.assign({}, state)

    default:
      return state
  }
}

export type updateHistoryEntryType = (entry: any) => any
export const updateHistoryEntry = (entry: any) => async (dispatch: Dispatch<Action>) => {
  await dispatch({
    type: actionTypes.UPDATE,
    entry
  })
}

export type checkAllEntriesType = () => any
export const checkAllEntries = () => async (dispatch: Dispatch<Action>, getState: GetState) => {
  const state = getState()

  const entries = (await Promise.all(
    Object.values(state.history.list).map(async (entry: any) => {
      if (!['wait_for_signature', 'error'].includes(entry.status)) {
        return null
      }

      try {
        const result = await client.query<QuoteStatusData, QuoteStatusVariables>({
          query: QUOTE_STATUS_QUERY,
          variables: {
            id: entry.id
          }
        })

        return result.data.quote
      } catch (e) {
        return entry
      }
    })
  )).filter(e => !!e)

  if (entries.length === 0) {
    return
  }

  await dispatch({
    type: actionTypes.UPDATE_MANY,
    entries
  })
}

export type createHistoryEntryType = (entry: any) => any
export const createHistoryEntry = (entry: any) => async (dispatch: Dispatch<Action>) => {
  await dispatch({
    type: actionTypes.CREATE,
    entry
  })
}

export const historyInitialize = () => async (dispatch: Dispatch<Action>) => {
  // await handleUser(userPool.getCurrentUser(), dispatch)
}
